import React from "react";
import { Button, Classes } from "@blueprintjs/core";
import { Box, InlineSpinnerIcon, ThemedDialog } from "ui-components";
import { TaskT } from "ui-io/task-io/task-t";
import { taskEventMutation } from "ui-io/queries/tasks/task-event-mutation";
import { useMutation, useQuery, useQueryClient } from "react-query";
// import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/tasks-query'
import { delay } from "ui-lib/delay";
import { useNavigate } from "react-router-dom";
import { taskLookupQuery } from "ui-io/queries/tasks/task-user-list-query";
// import { useSessionState } from '@maps-internal/neutron-react-client'
import useSession from "ui-io/use-session";

import toasts from "../../utils/toasts";
import { formatLocation } from "../../routes";
import useVerification from "../use-verification";
import { TASKS_QUERY_FILTER } from "ui-io/queries/tasks/task-query";
import { TASKS_SEARCH_QUERY } from "ui-io/queries/tasks/tasks-query";

const RejectToEdit = ({
  task,
  isModalOpen,
  setModelOpen,
}: {
  task: TaskT;
  isModalOpen: boolean;
  setModelOpen: (val:boolean) => void;
}) => {
  const history = useNavigate();
  const queryClient = useQueryClient();
  const { validator, isValidated, handleOnReset } = useVerification({
    toValidate: task.id,
  });
  // const { environment: env } = useSessionState()
  const { session } = useSession();
  const env = session?.environment;
  const username = session?.username || "";
  // const taskLookupConnection = useQuery(
  //   task.fsmId
  //     ? taskLookupQuery({ taskFSMId: task.fsmId, fsmRevision: 1, env })
  //     : { enabled: false },
  // )

  // const fsmGroup = taskLookupConnection.data?.fsm.relations?.fsm_groups[0]

  const mutation = useMutation(taskEventMutation, {
    onSuccess: async () => {
      toasts.success("Successfully sent the task to editing");
      await delay(500);
      queryClient.refetchQueries([TASKS_QUERY_FILTER]);
      queryClient.refetchQueries([TASKS_SEARCH_QUERY]);
      history(formatLocation.taskPeerReview({}));
    },
    onError: (error) => {
      toasts.error(`Error: ${error}`);
    },
    onSettled: () => {
      setModelOpen(false);
    },
  });

  const handleOnSubmit = () => {
    // const properties = fsmGroup
    //   ? {
    //       fsm_group: {
    //         fsm_group_id: fsmGroup.fsm_group_id,
    //         fsm_group_revision: fsmGroup.fsm_group_revision,
    //       },
    //     }
    //   : undefined
    mutation.mutate({
      taskId: task.id,
      eventType: "REJECTED_BY_PUBLISHER_TO_EDITOR",
      user: task.assignee || username,
      updatedBy: username,
      // properties,
    });
  };
  const closeModel = () => {
    setModelOpen(false);
  }

  const isLoading = mutation.isLoading;
  return (
    <>
    <Button
            icon="ban-circle"
            onClick={() => {
              setModelOpen(true);
            }}
            // disabled={disabled}
            intent="warning"
          >
            {mutation.isLoading ? (
              <>
                Publishing
                <Box mx="small" inline>
                  <InlineSpinnerIcon />
                </Box>
              </>
            ) : (
              "Reject to Edit"
            )}
          </Button>
      <ThemedDialog
        isOpen={isLoading || isModalOpen}
        title="Reject to Edit"
        onClose={closeModel}
        onClosing={handleOnReset}
        icon="ban-circle"
      >
        <div className={Classes.DIALOG_BODY}>
          This action will send this task back to editor. If you are sure that
          this is what you want to do, please type in the last five characters
          of the task ID:
          {validator}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={closeModel} disabled={isLoading}>
              Cancel
            </Button>
            <Button
              intent="primary"
              disabled={!isValidated}
              loading={isLoading}
              onClick={handleOnSubmit}
            >
              Reject
            </Button>
          </div>
        </div>
      </ThemedDialog>
    </>
  );
};

export default RejectToEdit;
